module.exports = __webpack_public_path__ + "peerGroupAnalysisAsset.2f98c9a02845461c3bc55fd472c6069d.png";